import { GlobalSettingsContext } from 'context/GlobalSettingsContext'
import * as React from 'react'

export function useGlobalSettings() {
  return React.useContext(GlobalSettingsContext)
}
